const ROOTPATH = "http://www.cangshutuan.com/";

export default {
	APIHOST:"/app?r=",
	ROOTPATH:ROOTPATH
}